module.exports = {
  DefaultDashboard: 'Bảng điều khiển mặc định',
  Edit: 'Chỉnh sửa',
  PleaseSelectABranch: 'Vui lòng chọn chi nhánh',
  PleaseSelectADepartment: 'Vui lòng chọn phòng ban',
  PleaseChooseDepartmentPersonnel: 'Vui lòng chọn nhân viên phòng ban',
  BIDashboardSource: 'Nguồn bảng điều khiển BI',
  SelectBIDashboardSource: 'Vui lòng chọn nguồn bảng điều khiển BI',
  BiExpiredTip: 'Kính gửi quý khách, gói BI bạn đã mua đã hết hạn.<br>Vui lòng gia hạn để tiếp tục sử dụng, có thể liên hệ nhân viên bán hàng hoặc bộ phận hỗ trợ khách hàng.<br><div style="margin-top: 5px;">Gói BI sẽ bị hạn chế truy cập, dữ liệu sẽ được giữ nguyên. Sau khi gia hạn, bạn có thể sử dụng lại.</div>'
}
